import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/miranda-react'
import { toCSSValue } from '@loadsmart/miranda-react/dist/tokens'

import { screen } from 'legacy/styles/screen'

export const ResponsiveBox = styled(Layout.Box)`
  display: flex;
  flex-direction: column;
  gap: ${toCSSValue('spacing-4')};
  padding: ${toCSSValue('spacing-4')} ${toCSSValue('spacing-5')};

  ${screen.md} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: ${toCSSValue('spacing-6')};
  }

  ${screen.lg} {
    gap: ${toCSSValue('spacing-10')};
  }
`

export const ResponsiveGroup = styled(Layout.Group)`
  gap: ${toCSSValue('spacing-6')};

  ${screen.lg} {
    gap: ${toCSSValue('spacing-10')};
  }
`
